import { render } from "./OrderSagaTracePanel.vue?vue&type=template&id=6e0b53b5&scoped=true"
import script from "./OrderSagaTracePanel.vue?vue&type=script&lang=js"
export * from "./OrderSagaTracePanel.vue?vue&type=script&lang=js"

import "./OrderSagaTracePanel.vue?vue&type=style&index=0&id=6e0b53b5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0b53b5"]])

export default __exports__